export interface TargetEventHandlers {
  onTargetFound(): void;
  onTargetLost(): void;
}

export function bindTargetEvents(target: EventTarget, handlers: TargetEventHandlers): () => void {
  const handleFound = (): void => {
    handlers.onTargetFound();
  };
  const handleLost = (): void => {
    handlers.onTargetLost();
  };

  target.addEventListener("targetFound", handleFound);
  target.addEventListener("targetLost", handleLost);

  return () => {
    target.removeEventListener("targetFound", handleFound);
    target.removeEventListener("targetLost", handleLost);
  };
}
